<script setup lang="ts">
import { SphAccordion, SphAccordionItem } from '@/components/base/accordion';
import SectionClubRelationForm from './SectionClubRelationForm.vue';
import SectionFederationEmployeeRelationForm from './SectionFederationEmployeeRelationForm.vue';
import SectionKindergartenRelationForm from './SectionKindergartenRelationForm.vue';
import SectionPage from './SectionPage.vue';
import { ref } from 'vue';
import { useI18n } from '@/composables/i18n';

defineOptions({
    compatConfig: { MODE: 3 },
})

const { i18n } = useI18n()

defineProps<{
    federationId: number
}>()

const openAccordionItem = ref('bereiche')
</script>

<template>
    <div>
        <SphAccordion v-model:model-value="openAccordionItem">
            <SphAccordionItem
                value="bereiche"
                :label="i18n.t('Bereiche')"
            >
                <SectionPage :federation-id="federationId" />
            </SphAccordionItem>
            <SphAccordionItem
                value="einrichtung"
                :label="i18n.t('Einrichtung')"
            >
                <SectionKindergartenRelationForm :federation-id="federationId" />
            </SphAccordionItem>
            <SphAccordionItem
                value="verein"
                :label="i18n.t('Verein')"
            >
                <SectionClubRelationForm :federation-id="federationId" />
            </SphAccordionItem>
            <SphAccordionItem
                value="traegermitarbeiter"
                :label="i18n.t('Trägermitarbeiter')"
            >
                <SectionFederationEmployeeRelationForm :federation-id="federationId" />
            </SphAccordionItem>
        </SphAccordion>
    </div>
</template>
